import React from "react";
import { Popover, Tag } from "antd";
import { CaretDownOutlined, CloseOutlined } from "@ant-design/icons";
import { squareRounded } from "../../../../constants/events";
import saveIcon from "../../../../assets/images/Check.svg";
import clearIcon from "../../../../assets/images/X.svg";

const RoleCompositionTrigger = ({
  roleCompTemp,
  roleCompTags,
  showEditIcon,
  isEditable,
  popoverContent,
  popoverOpen,
  onPopoverOpenChange,
  onTagClose,
  onSave,
  onCancel,
  onTriggerClick,
}) => (
  <Popover
    placement="bottomLeft"
    content={popoverContent}
    arrow={false}
    trigger="click"
    overlayClassName="role-composition-popover"
    open={popoverOpen}
    onOpenChange={onPopoverOpenChange}
  >
    <div
      className="border border-grayLight rounded w-full uppercase p-2 gap-1 text-xs relative [&.ant-popover-open]:border-richBlue"
      onClick={onTriggerClick}
    >
      <div className="flex flex-row">
        <label className="font-semibold font-inter text-sm text-[#393636]" htmlFor={roleCompTemp?.id}>
          {roleCompTemp?.label}
        </label>
        {roleCompTemp?.required && squareRounded()}
      </div>

      {roleCompTags.length > 0 ? (
        <div className={`mt-2 ${!showEditIcon || isEditable ? "opacity-100" : "opacity-70"}`}>
          {roleCompTags.map((comp, i) => (
            <Tag
              key={i}
              color="#F1EEFA"
              style={{ color: "#000", fontSize: "12px", fontWeight: "500", marginInlineEnd: "2px", whiteSpace: "break-spaces", wordBreak: "break-word" }}
              bordered={false}
              closable
              closeIcon={<CloseOutlined className="!text-black !font-bold" />}
              onClose={(e) => { e.preventDefault(); onTagClose(e, comp); }}
            >
              {comp?.data}
            </Tag>
          ))}
        </div>
      ) : (
        <div className="mt-1 text-grayNobel text-sm font-inter normal-case">
          <p>Select all that apply</p>
        </div>
      )}

      {!showEditIcon && (
        <CaretDownOutlined className="absolute text-[#BFBFBF] bottom-[18px] right-[5px]" />
      )}

      {isEditable && (
        <div className="flex flex-col pr-1 z-[1] gap-2 absolute bottom-[18px] right-[5px]">
          <button type="button" aria-label="save edit" data-action="save" className="w-4 h-4 cursor-pointer" onClick={onSave}>
            <img src={saveIcon} alt="save edit" />
          </button>
          <button type="button" aria-label="clear edit" data-action="cancel" className="w-4 h-4 cursor-pointer" onClick={onCancel}>
            <img src={clearIcon} alt="clear edit" />
          </button>
        </div>
      )}
    </div>
  </Popover>
);

export default RoleCompositionTrigger;
